import React from 'react'
import { connect } from 'react-redux'
import { isAvailableGames } from '../shared/utils/functions'

const Hoc =
  (HocComponent) =>
  ({ countryCode, accountResourceId, gamblerId, ...props }) => {
    const isAvailable = isAvailableGames(countryCode, accountResourceId, gamblerId)
    if (isAvailable) {
      return <HocComponent {...props} />
    }
    props.router.push('/')
    return null
  }

export default (HocComponent) =>
  connect((state) => {
    const user = state.auth.get('user')
    const gamblerId = user ? user.get('gamblerId') : null
    const accountResourceId = user ? user.get('resourceId') : null
    const countryCode = state.application.get('countryCode')

    return {
      gamblerId,
      countryCode,
      accountResourceId,
    }
  })(Hoc(HocComponent))



// WEBPACK FOOTER //
// ./js/hoc/GamesRedirect.jsx